import { RiTeamFill, RiTeamLine } from '@remixicon/react'
import { Perm_Staff_View } from '../../app/hooks/premissionScreen'
import { createItem } from '../../help'
import ROUTES from '../../routers/helpersRouter/constantRouter'
import { MenuItem } from '../../types'

const icons = {
  RiTeamLine,
  RiTeamFill
}

export const staffAccountMenuItem: MenuItem = createItem({
  id: 'list-staff-account',
  title: 'Tài khoản nhân viên',
  url: `/${ROUTES.STAFF}/${ROUTES.INDEX}`,
  icon: icons.RiTeamLine,
  iconActive: icons.RiTeamFill,
  premissions: Perm_Staff_View
})
